var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',[_c('v-col',{staticClass:"text-center",attrs:{"cols":"9"}})],1),_c('div',[_c('object',{attrs:{"data":_vm.pdfDoc,"type":"application/pdf","width":"100%","height":"550vh"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }